import { striptags } from '@webapp/common/lib/utils';
import { QuestionType } from '@webapp/common/resources/survey';

// ПОЛУЧАТЕЛИ. Вопросы, у которых в названии можно использовать пайпинг
export const QUESTION_TYPES_WITH_PIPING = new Set([
    QuestionType.ONE_OF_LIST,
    QuestionType.TEST_ONE_OF_LIST,
    QuestionType.FEW_OF_LIST,
    QuestionType.TEST_FEW_OF_LIST,
    QuestionType.SELECT_ONE_IMAGE,
    QuestionType.SELECT_FEW_IMAGE,
    QuestionType.DROPDOWN_LIST,
    QuestionType.NESTED_LIST,
    QuestionType.SCALE,
    QuestionType.STAR,
    QuestionType.SMILE,
    QuestionType.NPS,
    QuestionType.MATRIX_DROPDOWN_LIST,
    QuestionType.MATRIX_FEW_ANSWERS,
    QuestionType.MATRIX_RATING,
    QuestionType.MATRIX_SINGLE_ANSWER,
    QuestionType.MATRIX_TEXT_ANSWER,
    QuestionType.CSI,
    QuestionType.DISTRIBUTE_SCALE,
    QuestionType.SHORT_TEXT,
    QuestionType.LONG_TEXT,
    QuestionType.GROUP_FREE_ANSWERS,
    QuestionType.RANK,
    QuestionType.TEST_RANK,
    QuestionType.TEXT_BLOCK,
    QuestionType.FIRST_CLICK,
    QuestionType.FIGMA_TEST,
    QuestionType.TEXT_PERCEPTION,
    QuestionType.PAIR_COMPARISON,
    QuestionType.CARD_SORTING,
    QuestionType.MAX_DIFF,
    QuestionType.VIDEO_TEST,
    QuestionType.FIVE_SEC_TEST,
    QuestionType.KANO,
    QuestionType.CONJOINT,
]);

// ОТПРАВИТЕЛИ. Список типов вопросов, которые могут быть отправителями
export const PIPING_SENDER_QUESTION_TYPES = [
    QuestionType.FEW_OF_LIST,
    QuestionType.ONE_OF_LIST,
    QuestionType.TEST_FEW_OF_LIST,
    QuestionType.TEST_ONE_OF_LIST,
    QuestionType.SHORT_TEXT,
    QuestionType.TEST_TEXT,
    QuestionType.NAME,
    QuestionType.FIRST_CLICK,
    QuestionType.FIGMA_TEST,
    QuestionType.DROPDOWN_LIST,
    QuestionType.NPS,
    QuestionType.SCALE,
];

export const getMappedPipingOptions = (questions) => {
    return questions
        .filter(({ type }) => PIPING_SENDER_QUESTION_TYPES.includes(type))
        .map((q) => ({
            label: striptags(q.name),
            value: q.id,
            order: q.order || 0,
        }));
};
